export default __webpack_public_path__ + "static/media/airplane.4a8df370.svg";